module.exports = __webpack_public_path__ + "static/Ehub-opengraph-image-737a3aaf49e580ce85f00ecf19b21dce.jpg";